import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { HttpProvider } from '../../providers/http/http';
import { OrdenPage } from '../orden/orden';

/**
 * Generated class for the PagoPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

// @IonicPage()
@Component({
  selector: 'page-pago',
  templateUrl: 'pago.html',
})
export class PagoPage {
  carrito: any = []
  path:any = this.http.images
  total: any = 0
  metodo: any = ''
  met: any = ''
  seleccion: any = false
  datos : any = []
  dat: any = {}
  constructor(
    public navCtrl: NavController, 
    public navParams: NavParams,
    public http: HttpProvider
    ) {
    if(window.localStorage.getItem('carrito')){
      this.carrito = JSON.parse(window.localStorage.getItem('carrito'))
      this.carrito.forEach(el=>{
        this.total+=el.precio*el.cant
      })
    }
    this.http.get('bancos').subscribe(
      (res:any)=>{
        this.datos = res
      },
      error=>console.log(error)
    )
  }

  cancelar(){
    this.seleccion = false 
  }

  selec(metodo){
    this.seleccion = !this.seleccion
    this.metodo = metodo
    if(this.metodo === 'Zelle'){
      this.met = 'Zelle'
      this.dat = this.datos.find(el=>el.categoria === 'Zelle')
    }else if(this.metodo === 'TI'){
      this.met = 'Transferencia Internacional'
      this.dat = this.datos.find(el=>el.categoria === 'Internacional')
    }else if(this.metodo == 'TDC'){
      this.seleccion = false
      this.navCtrl.push(OrdenPage,{metodo})
    }else{
      this.met = 'Transferencia Nacional'
      this.dat = this.datos.find(el=>el.categoria === 'Nacional')
    }
  }

  ordenar(){
    this.seleccion = false 
    this.navCtrl.push(OrdenPage,{metodo:this.metodo, met:this.met})
  }

}



// WEBPACK FOOTER //
// ./src/pages/pago/pago.ts